export default __webpack_public_path__ + "static/media/defaultMarker.49c26906.svg";